"use client";

import {
  createContext,
  useContext,
  useMemo,
} from "react";

import { Studio } from "@prisma/client";

interface StudioContext {
  studio: Studio | null;
}

export const StudioContext = createContext<StudioContext>({
  studio: null,
});

export function StudioProvider({
  children,
  studio = null,
}: {
  children: React.ReactNode;
  studio?: Studio | null;
}) {
  const contextValue = useMemo<StudioContext>(() => ({ studio: studio }), [studio]);

  return (
    <StudioContext.Provider value={contextValue}>
      {children}
    </StudioContext.Provider>
  );
}

export function useStudio() {
  return useContext(StudioContext);
}
